import { forwardRef } from 'react';
import { Vector3 } from 'three';

import {
  Decoration as BaseDecoration,
  DecorationProps as BaseDecorationProps,
} from '@spazious/dollhouse-engine';
import { Instance } from '@spazious/dollhouse-three';
import { useForkRef } from '@spazious/react-hooks';

import { useFloorPosition } from '../../hooks/index.js';

export interface DecorationProps extends Omit<BaseDecorationProps, 'position'> {
  position: Parameters<Vector3['set']>;
}

export const Decoration = forwardRef<Instance, DecorationProps>(
  ({ position, ...restProps }, ref) => {
    const { floorPosition, nodeRef } = useFloorPosition(position);
    const forkedRef = useForkRef(ref, nodeRef);

    return <BaseDecoration ref={forkedRef} position={floorPosition} {...restProps} />;
  }
);
